import '../styles/main_style.css';

function Footer() {
    return (
        <footer className="cusfooter">
            <p style={{marginTop: '0px', marginBottom: '0px'}}>tkazarin</p>
            <p style={{marginTop: '0px', marginBottom: '0px'}}>2025</p>
        </footer>
    );
}

export default Footer;